import cart from './modules/cart'
import products_list from './modules/products_list'
import newsletter from './modules/newsletter'
import nav from './modules/nav'
import product from './modules/product'
import checkout from './modules/checkout'
import user from './modules/user'
import my_account_history from './modules/my_account_history'
import my_account_addresses from './modules/my_account_addresses'
import shipping_zones from './modules/shipping_zones'
import info_boxes from './modules/info_boxes'
import contact from './modules/contact'
import countries_list from './modules/countries_list'
import shops_list from './modules/shops'
import alerts from './modules/alerts'
import waitlist from './modules/waitlist'

export default {
    modules: {
        cart,
        products_list,
        newsletter,
        product,
        checkout,
        user,
        my_account_history,
        my_account_addresses,
        shipping_zones,
        info_boxes,
        contact,
        countries_list,
        shops_list,
        alerts,
        waitlist
    },
    state: {},
    mutations: {},
    getters: {}
};